import { type LucideIcon, Package, Truck, Warehouse } from "lucide-react"

export const getShiftTypeIcon = (value: string): LucideIcon => {
  const normalized = value.toLowerCase()
  if (normalized.includes("collect")) return Package
  if (normalized.includes("sort")) return Warehouse
  return Truck
}
